import Args from "../Args";
import {Mixins} from "../../Mixins";
import {MtsBelge} from "../../MtsXmlParser";
import MtsDiger from "./MtsDiger";
import MtsAlacakKalem from "./MtsAlacakKalem";
import TarafKisi from "../TarafKisi";
import TarafKurum from "../TarafKurum";

export default class MtsIlamsizParser {
    turksatMersisNo = "0881026377200139";
    enerjisaMersisNoArray = ["0335043212300017","0481057763500017"];
    maskiVergiNo = "6190017850";
    digerNodeList !: NodeListOf<Element>;
    id: number = 0; //counter
    icraproXmliMi = false;
    belgeList: MtsBelge[] = [];
    tarafList: Array<TarafKisi | TarafKurum> = [];
    ilamsizList: MtsDiger[] = [];

    static parse(digerNodeList: NodeListOf<Element>,
                 belgeList: MtsBelge[],
                 tarafList: Array<TarafKisi | TarafKurum>,
                 args: Args): MtsDiger[] {
        if (digerNodeList) {
            let mtsIlamsiz = new MtsIlamsizParser();
            mtsIlamsiz.digerNodeList = digerNodeList;
            mtsIlamsiz.tarafList = tarafList;
            mtsIlamsiz.belgeList = belgeList;
            mtsIlamsiz.icraproXmliMi = args.icraproXmliMi;
            if (mtsIlamsiz.belgeVarmi()) {
                if (mtsIlamsiz.isTurksatXml() === true && mtsIlamsiz.isIcraproXml() === false)
                    mtsIlamsiz.turksatXmlParser();
                else if (mtsIlamsiz.isEnerjisaXml())
                    mtsIlamsiz.enerjisaXmlParser();
                else
                    mtsIlamsiz.digerKurumlaraOzelXmlParser();
            } else {
                mtsIlamsiz.digerParser();
            }
            return mtsIlamsiz.getIlamsizList();
        }
        return [];
    }

    getIlamsizList(): MtsDiger[] {
        return this.ilamsizList;
    }

    pushIlamsizList(ilamsiz: MtsDiger) {
        this.ilamsizList.push(ilamsiz);
        this.id++;
    }

    digerParser() {
        this.digerNodeList.forEach((digerNode: Element) => {
            let mtsDiger = new MtsDiger();
            let alacakKalemleriNodeList = digerNode.querySelectorAll('alacakkalemi');
            let digerAlacakAciklama: any = Mixins.nullUndefCleaner(digerNode.getAttribute("digeralacakaciklama"));
            mtsDiger.id = this.id;
            mtsDiger.tarih = Mixins.tarihConverter(digerNode.getAttribute("tanzimtarihi"));//getDateNow();
            mtsDiger.muacceliyetTarihi = Mixins.tarihConverter(digerNode.getAttribute("tarih"));
            mtsDiger.no = Mixins.nullUndefCleaner(digerNode.getAttribute("alacakno"));
            mtsDiger.tutarTL = Mixins.replaceCommaDots(digerNode.getAttribute("tutar"));
            mtsDiger.aciklama = digerAlacakAciklama;
            if (alacakKalemleriNodeList.length > 0)
                this.setAlacakKalemleri(alacakKalemleriNodeList, mtsDiger);
            this.pushIlamsizList(mtsDiger);
        })
    }

    setAlacakKalemleri(alacakKalemleriNodeList: any, mtsDiger: MtsDiger) {
        let digerAlacakAciklama: any = mtsDiger.aciklama;
        if (!this.isIcraproXml())  //Sadece icrapro xmllerinde calismasi icin eup 230
            digerAlacakAciklama = null;
        let alacakKalemleri = this.createAlacakKalem(alacakKalemleriNodeList, digerAlacakAciklama);
        mtsDiger.alacakKalemleri = mtsDiger.alacakKalemleri.concat(alacakKalemleri);
        /*
       alacakKalemleriNodeList.forEach((node:Element)=>{
           let alacakKalem = MtsAlacakKalem.parse(node, this.tarafList,digerAlacakAciklama);
           if(alacakKalem != null){
               mtsDiger.alacakKalemleri.push(alacakKalem);
           }
       });
         */
    }

    createAlacakKalem(alacakKalemleriNodeList: any, digerAlacakAciklama = null): MtsAlacakKalem[] {
        let alacakKalemleri: MtsAlacakKalem[] = [];
        alacakKalemleriNodeList.forEach((node: Element , key: number) => {

            let alacakKalem = MtsAlacakKalem.parse(node, this.tarafList, key , digerAlacakAciklama);
            if (alacakKalem != null) {
                alacakKalemleri.push(alacakKalem);
            }
        });
        return alacakKalemleri;
    }

    digerKurumlaraOzelXmlParser() {
        let ignoreAlacakKalemIds: any[] = [];

        this.digerNodeList.forEach(digerNode => {
            let alacakKalemleriNodeList = digerNode.querySelectorAll('alacakkalemi');
            alacakKalemleriNodeList.forEach(alacakKalemiNode => {
                let alacakKalemId = Mixins.onlyDigit(alacakKalemiNode.getAttribute("id"));

                this.belgeList.forEach(belge => {
                    if ((alacakKalemId == belge.id) || this.isMaskiXml()) {
                        let mtsDiger = new MtsDiger();
                        mtsDiger.tutarTL = Mixins.replaceCommaDots(alacakKalemiNode.getAttribute("alacakkalemtutar"));
                        if (mtsDiger.tutarTL == 0)
                            return;
                        mtsDiger.id = this.id;
                        mtsDiger.tarih = belge.faturaTarihi
                        mtsDiger.no = belge.faturaId;
                        mtsDiger.muacceliyetTarihi = belge.odemeTarihi;
                        mtsDiger.aciklama = Mixins.nullUndefCleaner(alacakKalemiNode.getAttribute("alacakkalemkodaciklama"));

                        if (alacakKalemiNode.getAttribute("alacakkalemkod") == "6") {
                            ignoreAlacakKalemIds.push(alacakKalemId);
                        }

                        this.setAlacakKalemleri([alacakKalemiNode], mtsDiger);
                        if (mtsDiger.alacakKalemleri.length == 0)
                            return;

                        this.pushIlamsizList(mtsDiger);
                    }

                });
            });

            //EUP-504
            if (this.ilamsizList.length > 0) {
                let islemisFaizJsonAlacakKalemleri = this.islemisFaizAlacakKalemleri(alacakKalemleriNodeList, ignoreAlacakKalemIds);
                this.ilamsizList[0].alacakKalemleri = this.ilamsizList[0].alacakKalemleri.concat(islemisFaizJsonAlacakKalemleri);
            }
            //END OF EUP-504

        });


    }





    islemisFaizAlacakKalemleri(alacakKalemleri: NodeListOf<Element>, ignoreAlacakKalemIds: any[]) {
        let alacakKalemleriNodeList: any[] = [];
        alacakKalemleri.forEach(alacakKalemiNode => {
            let alacakKalemId = Mixins.onlyDigit(alacakKalemiNode.getAttribute("id"));
            let idExists = ignoreAlacakKalemIds.find((x: any) => x == alacakKalemId);
            //@ts-ignore
            if (!idExists && alacakKalemiNode.getAttribute("alacakkalemkod") == 6) {
                alacakKalemleriNodeList.push(alacakKalemiNode);
            }
        });
        return this.createAlacakKalem(
            alacakKalemleriNodeList,
            null
        );
    }

    enerjisaXmlParser() {
        let kullanilanBelgeIdList: any[] = [];
        this.digerNodeList.forEach(digerNode => {
            let alacakKalemleriNodeList = digerNode.querySelectorAll('alacakkalemi');
            let digerTarih = Mixins.getCleanAttribute(digerNode, "tarih");
            let digerTutar = Mixins.getCleanAttribute(digerNode, "tutar");

            let mtsDiger = new MtsDiger();
            //DEV-2625 tutar her zaman xmldeki digerAlacak tutari, faturanin acik tutari degil.
            mtsDiger.tutarTL = Mixins.replaceCommaDots(digerNode.getAttribute("tutar"));
            if (mtsDiger.tutarTL == 0)
                return;
            mtsDiger.id = this.id;
            mtsDiger.aciklama = Mixins.getCleanAttribute(digerNode, "digeralacakaciklama");

            let belge = this.enerjisaBelgeBul(digerTarih, digerTutar, kullanilanBelgeIdList);
            if (belge) {
                kullanilanBelgeIdList.push(belge.id);
                mtsDiger.tarih = belge.faturaTarihi;
                mtsDiger.no = belge.faturaId;
                mtsDiger.muacceliyetTarihi = belge.odemeTarihi;
            } else {
                //DEV-2625 fatura eslesmese de alacak kalemleri dusmemeli, xmlin kendi verisi ile devam ediliyor.
                console.warn("Enerjisa XML: digerAlacak icin fatura bulunamadi.", {digerTarih, digerTutar});
                mtsDiger.tarih = Mixins.tarihConverter(digerNode.getAttribute("tanzimtarihi"));
                mtsDiger.no = Mixins.nullUndefCleaner(digerNode.getAttribute("alacakno"));
                mtsDiger.muacceliyetTarihi = Mixins.tarihConverter(digerNode.getAttribute("tarih"));
            }

            if (alacakKalemleriNodeList.length > 0) {
                this.setAlacakKalemleri(alacakKalemleriNodeList, mtsDiger)
            }
            this.pushIlamsizList(mtsDiger);
        })
    }

    /**
     * DEV-2625 - Enerjisa xmllerinde digerAlacak tutari ile faturanin acik tutari her zaman ayni olmuyor
     * (kismi odeme, kdv/gecmis donem faizi ayrismasi vb.). Once tarih+tutar, tutmazsa sadece odeme tarihi
     * ile eslestiriliyor. Ayni faturanin iki bloga baglanmamasi icin kullanilmamis belgelere oncelik veriliyor.
     */
    enerjisaBelgeBul(digerTarih: string, digerTutar: string, kullanilanBelgeIdList: any[]): MtsBelge | undefined {
        let bul = (belgeList: MtsBelge[]) =>
            belgeList.find(belge => digerTarih == belge.odemeTarihi && digerTutar == belge.acikTutar) ||
            belgeList.find(belge => digerTarih == belge.odemeTarihi);
        let kullanilmayanBelgeler = this.belgeList.filter(belge => kullanilanBelgeIdList.indexOf(belge.id) === -1);
        return bul(kullanilmayanBelgeler) || bul(this.belgeList);
    }

    turksatXmlParser() {
        let digerNode = this.digerNodeList[0];
        let alacakKalemiNodeList = digerNode.querySelectorAll('alacakkalemi'); //ilkini al
        let alacakKalemiNode = alacakKalemiNodeList[0];
        //DEV-3656 belgelerin acik tutarlari asil alacakla tutmuyorsa takip xmlin alacak kalemleri ile tek dayanaktan acilir.
        if (!this.turksatBelgeToplamiTutuyorMu(alacakKalemiNode)) {
            this.turksatTekDayanakParser(alacakKalemiNodeList, alacakKalemiNode);
            return;
        }
        let counter = 0;
        this.belgeList.forEach(belge => {
            if (belge.acikTutar <= 0)
                return;
            let mtsDiger = new MtsDiger();
            mtsDiger.tutarTL = belge.acikTutar;
            mtsDiger.id = this.id;
            mtsDiger.tarih = belge.faturaTarihi;
            //DEV-3656 belge.id Türksat'ın iç kayıt no'su; alacak belgesindeki (pdf) fatura no faturaId.
            mtsDiger.no = belge.faturaId || belge.id;
            mtsDiger.muacceliyetTarihi = belge.odemeTarihi;
            mtsDiger.aciklama = Mixins.nullUndefCleaner(alacakKalemiNode.getAttribute("alacakkalemkodaciklama"));
            //Alacak kalem tutari farkli oldugu icin o ilamsizin tutari ekleniyor.
            alacakKalemiNode.setAttribute("alacakkalemtutar", mtsDiger.tutarTL);
            alacakKalemiNode.setAttribute("alacakKalemIlkTutar", mtsDiger.tutarTL);

            let alacakKalemleri: MtsAlacakKalem[] = [];
            if (alacakKalemiNodeList.length > 1 && counter == 0) {
                //alcakKalemleri islemis faiz varsa bikerelik ilamsiza ekleniyor.TT ye yansimasi icin
                this.setAlacakKalemleri(alacakKalemiNodeList, mtsDiger);
                counter++;
            } else {

                //alcakKalemleri sadece o alacak kaleminin faiz i islensin diye ilk alacak kalemi gonderiliyor.
                let alacakKalem = MtsAlacakKalem.parse(alacakKalemiNode, this.tarafList);
                if (alacakKalem)
                    alacakKalemleri.push(alacakKalem);
            }
            if (alacakKalemleri.length != 0)
                mtsDiger.alacakKalemleri = alacakKalemleri;

            this.pushIlamsizList(mtsDiger);
        });
    }

    /**
     * DEV-3656 - Fatura bazli bolme (belge acikTutar) ancak belgelerin toplami ilk alacak kaleminin (asil alacak)
     * tutarina esitse xml ile ayni takip tutarini verir. Esit degilse takibe giren tutar alacak kalemleridir
     * (asil alacak + islemis faiz); belgeler sadece dayanagin no/tarih/vade bilgisi icin kullanilir.
     */
    turksatBelgeToplamiTutuyorMu(asilAlacakNode: Element): boolean {
        let asilAlacak = parseFloat(Mixins.replaceCommaDots(asilAlacakNode.getAttribute("alacakkalemtutar")));
        let belgeToplami = 0;
        this.belgeList.forEach(belge => {
            let acikTutar = parseFloat(Mixins.replaceCommaDots(belge.acikTutar));
            if (acikTutar > 0)
                belgeToplami += acikTutar;
        });
        return Math.abs(asilAlacak - belgeToplami) < 0.01;
    }

    /**
     * DEV-3656 - Tutarlar xmlin alacak kalemlerinden gelir. UYAP dayanakta tarih istedigi ve xmlde tarih sadece
     * belgelerde oldugu icin no/tarih/vade, acik tutari asil alacaga esit faturadan; yoksa ilk faturadan aliniyor.
     */
    turksatTekDayanakParser(alacakKalemiNodeList: NodeListOf<Element>, asilAlacakNode: Element) {
        let asilAlacakTutar = Mixins.replaceCommaDots(asilAlacakNode.getAttribute("alacakkalemtutar"));
        let belge = this.belgeList.find(fatura =>
            Math.abs(parseFloat(Mixins.replaceCommaDots(fatura.acikTutar)) - parseFloat(asilAlacakTutar)) < 0.01
        ) || this.belgeList[0];
        let mtsDiger = new MtsDiger();
        mtsDiger.id = this.id;
        mtsDiger.tutarTL = asilAlacakTutar;
        mtsDiger.tarih = belge.faturaTarihi;
        mtsDiger.no = belge.faturaId || belge.id;
        mtsDiger.muacceliyetTarihi = belge.odemeTarihi;
        mtsDiger.aciklama = Mixins.nullUndefCleaner(asilAlacakNode.getAttribute("alacakkalemkodaciklama"));
        this.setAlacakKalemleri(alacakKalemiNodeList, mtsDiger);
        if (mtsDiger.alacakKalemleri.length == 0)
            return;
        this.pushIlamsizList(mtsDiger);
    }

    kurumVarmi() {
        return this.tarafList.find(taraf => taraf.isKurum());
    }

    belgeVarmi(): boolean {
        return this.belgeList.length > 0;
    }

    isEnerjisaXml(): boolean {
        return this.tarafList.some(taraf =>
            this.enerjisaMersisNoArray.includes(taraf?.temelBilgileri?.mersisNo)
        );
    }

    isTurksatXml(): boolean {
        if (this.tarafList.find(taraf => taraf.temelBilgileri.mersisNo == this.turksatMersisNo))
            return true;
        return false;
    }

    isMaskiXml(): boolean {
        if (this.tarafList.find(taraf => taraf.temelBilgileri.vergiNo == this.maskiVergiNo))
            return true;
        return false;
    }

    isIcraproXml(): boolean {
        return this.icraproXmliMi === true;
    }
}

